import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ui from 'redux-ui';
import MenuItem from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuItem';
import { Field, change } from 'redux-form';
import FormHelperText from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormHelperText';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import ListSubheader from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListSubheader';
import FormTextField from '../../Form/FormTextField.js';
import HCGoogleMapsAutoComplete from '../../../HCGoogleMapsAutoComplete/HCGoogleMapsAutoComplete';
import { OPTION_ALL, OPTION_CANADA, provinceOptions, stateOptions } from '../../Form/AddressData';
import { isPresent } from 'utils/isPresent';

@connect(
  (state) => ({}),
  (dispatch) => ({
    onAutocompleteSuccess: (formName, fields) => {
      fields.map((entry) => {
        dispatch(change(formName, entry.field, entry.value));
      });
    },
  })
)
@ui({
  state: {
    cityText: 'City',
    stateOptions: stateOptions,
    stateText: 'State',
    zipText: 'Zip',
  },
  reducer: (state, action) => {
    switch (action.type) {
    }
    return state || new Map();
  },
})
export default class AddressFormSection extends PureComponent {
  componentDidMount() {
    this.updateAddressLabel(this.props.countryOption);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.countryOption !== this.props.countryOption) {
      this.updateAddressLabel(newProps.countryOption);
    }
  }

  updateAddressLabel(countryOption) {
    switch (countryOption) {
      case OPTION_CANADA:
        this.props.updateUI('cityText', 'Municipality');
        this.props.updateUI('stateOptions', provinceOptions);
        this.props.updateUI('stateText', 'Province');
        this.props.updateUI('zipText', 'Postal code');
        break;
      default:
        this.props.updateUI('cityText', 'City');
        this.props.updateUI('stateOptions', stateOptions);
        this.props.updateUI('stateText', 'State');
        this.props.updateUI('zipText', 'Zip');
    }
  }

  checkCountry(zip) {
    var country = 'CA';
    if (zip.length === 5) {
      country = 'US';
    }
    return country;
  }

  streetField(namePrefix) {
    const googleMapsAutoCompleteCallback = (streetComponents) => {
      this.props.onAutocompleteSuccess(this.props.formName, [
        {
          field: `${namePrefix}street`,
          value: streetComponents.formatted_address,
        },
      ]);

      let fields = [
        { field: `${namePrefix}street`, value: streetComponents.street },
        { field: `${namePrefix}city`, value: streetComponents.city },
        { field: `${namePrefix}state`, value: streetComponents.state },
        { field: `${namePrefix}zip`, value: streetComponents.postal_code },
        { field: `${namePrefix}latitude`, value: streetComponents.latitude },
        { field: `${namePrefix}longitude`, value: streetComponents.longitude },
        {
          field: `${namePrefix}country`,
          value: this.checkCountry(streetComponents.postal_code),
        },
      ];
      this.props.onAutocompleteSuccess(this.props.formName, fields);
      this.updateAddressLabel(streetComponents.country);
    };

    const autoCompleteTextFieldCallback = (event, value) => {
      this.props.onAutocompleteSuccess(this.props.formName, [{ field: `${namePrefix}street`, value: value }]);
    };

    return (
      <Field
        name={`${namePrefix}street`}
        component={({ input, meta: { touched, error } }) => {
          let hasError = touched && isPresent(error);

          return (
            <div>
              <HCGoogleMapsAutoComplete
                id={`${namePrefix}streetAutoComplete`}
                floatingLabelText="Street"
                useLatestMaterialUI={this.props.useLatestMaterialUI}
                newMaterialUI={!this.props.useLatestMaterialUI}
                disabled={this.props.ui.disableFields}
                onAutoComplete={googleMapsAutoCompleteCallback}
                onTextFieldChange={autoCompleteTextFieldCallback}
                value={input.value}
                error={hasError}
                variant={this.props.variant}
              />
              {hasError && <FormHelperText error={true}>{error}</FormHelperText>}
            </div>
          );
        }}
      />
    );
  }

  unitField(namePrefix) {
    return (
      <FormTextField
        name={`${namePrefix}street_line_2`}
        placeholder="Unit"
        label="Unit"
        disabled={this.props.ui.disableFields}
        fullWidth={true}
        variant={this.props.variant}
      />
    );
  }

  cityField(namePrefix) {
    return (
      <FormTextField
        name={`${namePrefix}city`}
        placeholder="City"
        label={this.props.ui.cityText}
        disabled={this.props.ui.disableFields}
        fullWidth={true}
        variant={this.props.variant}
      />
    );
  }

  stateMenus(stateOptions) {
    return stateOptions.map((state) => (
      <MenuItem value={state.value} key={state.key + state.value}>
        {state.value}
      </MenuItem>
    ));
  }

  stateSelection() {
    let options = [];
    if (this.props.countryOption === OPTION_ALL) {
      options.push(<ListSubheader key="state">States</ListSubheader>);
      options = options.concat(this.stateMenus(stateOptions));
      options.push(<Divider key="divider" />);
      options.push(<ListSubheader key="provinces">Provinces</ListSubheader>);
      options = options.concat(this.stateMenus(provinceOptions));
    } else {
      options = this.stateMenus(this.props.ui.stateOptions);
    }

    return options;
  }

  stateField(namePrefix) {
    return (
      <FormTextField
        name={`${namePrefix}state`}
        label={this.props.ui.stateText}
        InputLabelProps={{ shrink: true }}
        select={true}
        fullWidth={true}
        disabled={this.props.ui.disableFields}
        onBlur={(e) => {
          e.preventDefault();
        }}
        children={this.stateSelection()}
        variant={this.props.variant}
      />
    );
  }

  zipField(namePrefix) {
    return (
      <FormTextField
        name={`${namePrefix}zip`}
        label={this.props.ui.zipText}
        disabled={this.props.ui.disableFields}
        fullWidth={true}
        variant={this.props.variant}
      />
    );
  }

  render() {
    let namePrefix = '';
    if (isPresent(this.props.field)) {
      namePrefix = `${this.props.field}.`;
    }

    if (this.props.simple) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {this.streetField(namePrefix)}
          </Grid>
          <Grid item xs={6} md={6}>
            {this.cityField(namePrefix)}
          </Grid>
          <Grid item xs={6} md={6}>
            {this.stateField(namePrefix)}
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} md={9}>
            {this.streetField(namePrefix)}
          </Grid>
          <Grid item xs={6} md={3}>
            {this.unitField(namePrefix)}
          </Grid>

          <Grid item xs={6} md={5}>
            {this.cityField(namePrefix)}
          </Grid>
          <Grid item xs={6} md={4}>
            {this.stateField(namePrefix)}
          </Grid>
          <Grid item xs={6} md={3}>
            {this.zipField(namePrefix)}
          </Grid>
        </Grid>
      );
    }
  }
}

AddressFormSection.propTypes = {
  useLatestMaterialUI: PropTypes.bool,
  simple: PropTypes.bool,
  formName: PropTypes.string.isRequired,
  countryOption: PropTypes.string.isRequired,
  ui: PropTypes.object,
  updateUI: PropTypes.func,
  variant: PropTypes.string,
  field: PropTypes.string,
};

AddressFormSection.defaultProps = {
  useLatestMaterialUI: false,
  simple: false,
  field: '',
};
